module.exports = "/shifts/shift-swap/shift-swap-details-74f536.html";